import React, { useState } from 'react'
import { MDBContainer, MDBIcon, MDBModal, MDBModalBody, MDBModalHeader } from 'mdbreact'
import Comment from '../Comment'
import AddComment from '../AddComment'
import Fab from '@material-ui/core/Fab';
import RelatedBlogs from '../RelatedBlogs'
import Moment from 'react-moment'
import Markdown from 'markdown-to-jsx';
// import BlogAuthor from '../BlogAuthor'
//graphql
import { useQuery } from '@apollo/react-hooks'
import GET_CURRENT_BLOG from '../../queries/blog/getCurrentBlog'
import Loading from '../loaders/Loading'
import Error from '../loaders/Error'
import Navbar from '../Navbar'
import SEO from '../SEO'
import FooterWhite from '../FooterWhite'
import SearchModal from './SearchModal'
import { FacebookProvider, Share } from 'react-facebook';
import { PinterestButton } from "react-social";
import Lottie from 'lottie-react-web';
import pageConstruction from '../../img/page-construction.json';

const SingleBlog = ({match}) => {
    const [ show, setShow ] = useState(false);
    const [ shop, setShop ] = useState(false);

    const { data, loading, error } = useQuery(GET_CURRENT_BLOG, { variables: { blog: match.params.id } })

    if(loading) return <Loading/>
    if(error) return <Error/>

    const blog = data.blog
    const social = data.socialAccount

    return(
        <>
        <SEO title={`Blog - ${blog.title}`} image={blog.preview.url} description={blog.description}/>
        <Navbar show={show} onClick={()=>setShow(!show)} page="Blog"/>
        <div style={{ display: show ? "none" : "inline" }} className="single-blog-wrapper">
            <MDBContainer id="blog" className="mt-5 mb-5">
                <h1 className="h1-responsive font-weight-bold text-center">
                    {blog.title}
                </h1>
                <p className="grey-text text-center">
                    <Moment format="MMM DD, YYYY">{blog.createdAt}</Moment>
                </p>
                <small className="h6-responsive mt-4 mb-3 text-center d-lg-none d-md-none d-block">
                    Share this blog
                </small>
                <div className="d-flex d-md-none d-lg-none justify-content-center">
                    <FacebookProvider appId="614765702810449">
                        <Share href={`https://minimuni-blog.netlify.app/blog/${blog.id}`}>
                            {({ handleClick, loading }) => (
                        <a disabled={loading} onClick={handleClick} href={"#share-facebook"} className="black-text mx-3">
                            <MDBIcon fab icon="facebook-f"/>
                        </a>
                    )}
                        </Share>
                    </FacebookProvider>
                    <PinterestButton element="div"
                        className="mx-3"
                        media={blog.preview.url} message={`Blog - ${blog.title}`} 
                        url={`https://minimuni-blog.netlify.app/blog/${blog.id}`}>
                        <MDBIcon fab icon="pinterest-p"/>
                    </PinterestButton>
                    <a target="_blank" rel="noopener noreferrer" href={social.instagram} className="black-text mx-3">
                        <MDBIcon fab icon="instagram" />  
                    </a>
                    <a className="black-text mx-3" rel="noopener noreferrer" href={`https://twitter.com/intent/tweet?text=${encodeURI(`Read our blog - ${blog.title}, via our website.`)}%20https%3A%2F%2Fminimuni-blog.netlify.app%2Fblog%2F${blog.id}%23blog
`} target="_blank">                        
                        <MDBIcon fab icon="twitter"/>
                    </a>
                </div>
                <div className="d-md-flex d-lg-flex d-none flex-column position-absolute mr-auto justify-content-between p-3 text-center">
                    <Fab onClick={()=>setShop(!shop)} className="mt-2 mb-2" style={{ background: '#98bf64' }} aria-label="add">
                        <MDBIcon icon="dove white-text"/>
                    </Fab>
                    <FacebookProvider appId="614765702810449">
                        <Share href={`https://minimuni-blog.netlify.app/blog/${blog.id}`}>
                        {({ handleClick, loading }) => (
                        <Fab className="mt-2 mb-2" disabled={loading} onClick={handleClick} color="primary" aria-label="add">
                            <MDBIcon fab icon="facebook-f"/>
                        </Fab>
                        )}
                        </Share>
                    </FacebookProvider>
                     <PinterestButton element="span"
                        media={blog.preview.url} message={`Blog - ${blog.title}`} 
                        url={`https://minimuni-blog.netlify.app/blog/${blog.id}`}>
                        <Fab className="mt-2 mb-2" color='secondary' aria-label="pinterest">
                            <MDBIcon fab icon="pinterest-p"/>
                        </Fab>
                    </PinterestButton>
                    <a target="_blank" rel="noopener noreferrer" href={social.instagram}>
                        <Fab className="mt-2 mb-2" style={{ background: 'deep-orange-text' }} aria-label="instagram">
                            <MDBIcon fab icon="instagram deep-orange-text" />                    
                        </Fab>
                    </a>                    
                    <a rel="noopener noreferrer" href={`https://twitter.com/intent/tweet?text=${encodeURI(`Read our blog - ${blog.title}, via our website.`)}%20https%3A%2F%2Fminimuni-blog.netlify.app%2Fblog%2F${blog.id}%23blog
`} target="_blank">
                        <Fab className="mt-2 mb-2" style={{ background: "#33b5e5" }} aria-label="twitter">
                            <MDBIcon fab icon="twitter white-text" />
                        </Fab>
                    </a>
                </div>
                <MDBContainer style={{ fontSize: 'large' }} className="mt-5 w-75">
                    <div className="intro-section">
                        <Markdown
                            options={{
                                overrides: {
                                    h1: {
                                        props: {
                                            style: {
                                                fontWeight: '900'
                                            } 
                                        }
                                    },
                                    h2: {
                                        props: {
                                            style: {
                                                fontWeight: '900'
                                            } 
                                        }
                                    },
                                    h3: {
                                        props: {
                                            style: {
                                                fontWeight: '900'
                                            } 
                                        }
                                    },
                                    h4: {
                                        props: {
                                            style: {
                                                fontWeight: '900'
                                            } 
                                        }
                                    },
                                    h5: {
                                        props: {
                                            style: {
                                                fontWeight: '900'
                                            } 
                                        }
                                    },
                                    h6: {
                                        props: {
                                            style: {
                                                fontWeight: '900'
                                            } 
                                        }
                                    },
                                    b: {
                                        props: {
                                            style: {
                                                fontWeight: '900'
                                            } 
                                        }
                                    },
                                    strong: {
                                        props: {
                                            style: {
                                                fontWeight: '600'
                                            }
                                        }
                                    },
                                    img: {
                                        props: {
                                            className: "img-fluid"
                                        }
                                    }
                                }
                            }}
                        >
                            {blog.content}
                        </Markdown>
                    </div>   
                </MDBContainer>
                {/* <MDBContainer className="mt-5 mb-5 w-75">
                   <BlogAuthor blogID={blog.id}/>
                </MDBContainer> */}
                <MDBContainer style={{ marginTop: '15%' }} className="w-75 mb-5 overflow-mobile-ready">
                    <Comment blogID={blog.id}/>
                </MDBContainer>
                <MDBContainer style={{ marginTop: '10%' }} className="w-75 mb-5">
                    <AddComment blogID={blog.id}/>
                </MDBContainer>
                <MDBContainer className="mt-5 mb-5 w-75">
                    <RelatedBlogs blogID={blog.id} category={blog.blog_categories[0].category}/>
                </MDBContainer>
            </MDBContainer>
        <FooterWhite/>
        </div>
        <MDBModal isOpen={shop} centered>
            <MDBModalHeader toggle={()=>setShop(!shop)} style={{ border: 0 }}/>
            <MDBModalBody>
            <div className="p-5">
                <div className="text-center">
                <div>
                    <Lottie
                    options={{
                        animationData: pageConstruction
                    }}
                    />
                </div>
                <div className="mt-4">
                    <p className="font-weight-bold">
                      We'll be leaving the Blog part of Minimuni, we'll now go to the E-Commerce part of Minimuni.
                    </p>
                </div>
                <div>
                    <a href={social.shop} className="newsletter-subscription-button z-depth-1">I understand</a>
                </div>
                </div>
            </div>
            </MDBModalBody>
        </MDBModal> 
        <SearchModal onClick={()=>setShow(false)} show={show}/>
        </>
    )
}

export default SingleBlog
